export default {
  title: 'Top articles',
  columns: {
    name: 'Nom',
    quantity: 'Quantité',
    amount: 'Montant',
  },
};
